import RouteProvider from './RouteProvider';

class RouteService {
  constructor({ target }) {
    this._target = target;
  }

  getRoute() {
    return RouteProvider.currentTarget;
  }

  routeTo(subTarget) {
    RouteProvider.push(this._target, subTarget);
  }

  subscribeToRoute(callback, coursewareId) {
    return RouteProvider.subscribe(callback, coursewareId);
  }

  static build(...args) {
    return new RouteService(...args);
  }
}

export default RouteService;
